var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02515 0.75H2.97515C0.625146 0.75 0.443896 2.8625 1.71265 4.0125L8.28765 9.9875C9.5564 11.1375 9.37515 13.25 7.02515 13.25H2.97515C0.625146 13.25 0.443896 11.1375 1.71265 9.9875L8.28765 4.0125C9.5564 2.8625 9.37515 0.75 7.02515 0.75Z",
    stroke: "#758CA5",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockGlass);
export default __webpack_public_path__ + "static/media/clock-glass.0645affef17c3cdd1143a3c879ad9631.svg";
export { ForwardRef as ReactComponent };